<template>
  <span
    :class="{ [size]: true, [displayClass]: true }"
    class="align-items-center"
  >
    <img :alt="countrycode" :src="getImagePath(`flags/${countrycode}.png`)" />
    <span class="mx-1">{{ publicationname }}</span>
    <slot />
  </span>
</template>

<script setup lang="ts">import { computed as _computed } from 'vue';

withDefaults(defineProps<{
  publicationcode: string;
  publicationname: string;
  size?: string;
  displayClass?: string;
}>(), { size: "md",displayClass: "d-inline-flex", })

const { getImagePath } = images();

const countrycode = _computed(() => __props.publicationcode.split("/")[0]);
</script>

<style scoped lang="scss">
span.xl {
  font-size: 15pt;
  font-weight: bold;
}
</style>
